import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function PaymentFailure() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const bookingId =
    searchParams.get("bookingId") ||
    searchParams.get("BookingId") ||
    sessionStorage.getItem("lastBookingId") ||
    "";

  // ✅ Debug ke liye — Telr se jo bhi params aaye hain wo sab console mein dikhao
  useEffect(() => {
    const allParams = {};
    searchParams.forEach((value, key) => {
      allParams[key] = value;
    });

    console.log("❌ PAYMENT FAILURE PAGE LOADED");
    console.log("🔗 Full URL:", window.location.href);
    console.log("📋 All Query Params:", allParams);
    console.log("🎯 Booking ID (resolved):", bookingId);
    console.log("💾 sessionStorage lastBookingId:", sessionStorage.getItem("lastBookingId"));
    console.log("💾 sessionStorage lastUserKey:", sessionStorage.getItem("lastUserKey"));
    console.log("💾 sessionStorage lastAmount:", sessionStorage.getItem("lastAmount"));

    // Agar Telr specific error fields bhejta hai (jaise error, msg, reason, status)
    console.log("⚠️ Possible Telr Error Fields:", {
      error: searchParams.get("error"),
      message: searchParams.get("message"),
      reason: searchParams.get("reason"),
      status: searchParams.get("status"),
      cartid: searchParams.get("cartid"),
      declinereason: searchParams.get("declinereason"),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ padding: "60px 20px", textAlign: "center", minHeight: "50vh" }}>
      <div style={{ fontSize: 56, marginBottom: 16 }}>❌</div>
      <h1 style={{ fontSize: 26, fontWeight: 700, color: "#dc2626", margin: "0 0 12px" }}>
        Payment Failed
      </h1>
      <p style={{ color: "#6b7280", fontSize: 15, marginBottom: 8 }}>
        Unfortunately your payment could not be processed.
      </p>
      {bookingId && (
        <p style={{ color: "#9ca3af", fontSize: 13, marginBottom: 24 }}>
          Booking ID: <strong>{bookingId}</strong>
        </p>
      )}
      <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 24 }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: "12px 28px",
            borderRadius: 8,
            border: "1px solid #d1d5db",
            background: "#fff",
            color: "#374151",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          🔄 Try Again
        </button>
        <button
          onClick={() => navigate("/")}
          style={{
            padding: "12px 28px",
            borderRadius: 8,
            border: "none",
            background: "#dc2626",
            color: "#fff",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          🏠 Go Home
        </button>
      </div>
    </div>
  );
}